import React from 'react';
import { Users, FileText, Zap, Share2, BarChart3, Target, ChevronRight, ArrowRight } from 'lucide-react';
import { trackTeacherCTA } from '../../services/analytics';

const HowItWorksTeachers = ({ isDarkMode, onGetStarted }) => {
  const handleCTAClick = () => {
    trackTeacherCTA('how_it_works_teachers');
    onGetStarted('teacher');
  };

  const steps = [
    { step: '01', icon: FileText, title: 'Upload Materials', desc: 'Lesson plans, curriculum guides, PDFs, or slide decks.' },
    { step: '02', icon: Zap, title: 'Auto-Generate', desc: 'Customize question count, difficulty, and types.' },
    { step: '03', icon: Share2, title: 'Share to Class', desc: 'Direct link, PDF export, WhatsApp, or Google Classroom.' },
    { step: '04', icon: BarChart3, title: 'Track Performance', desc: 'Real-time scores, class averages, and reports.' },
    { step: '05', icon: Target, title: 'Identify Gaps', desc: 'See exactly which topics need re-teaching.' }
  ];

  return (
    <section data-testid="section-how-it-works-teachers" id="teachers-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-bold mb-4 ${isDarkMode ? 'text-emerald-400' : 'text-emerald-600'}`}>
            <Users className="w-4 h-4" />
            For Teachers
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-['Outfit'] tracking-tight mb-4">
            How AIQuizPark Works for Teachers
          </h2>
          <p className={`text-base sm:text-lg max-w-2xl mx-auto ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
            Save 90% of quiz preparation time with AI-powered assessment creation
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-4">
          {steps.map((item, i) => (
            <div key={i} data-testid={`teacher-step-${item.step}`} className={`relative p-5 rounded-xl text-center ${isDarkMode ? 'bg-slate-800/50 border border-slate-700' : 'bg-white border border-slate-200'}`}>
              <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl mb-4 ${isDarkMode ? 'bg-emerald-900/50' : 'bg-emerald-100'}`}>
                <item.icon className={`w-6 h-6 ${isDarkMode ? 'text-emerald-400' : 'text-emerald-600'}`} />
              </div>
              <div className={`text-xs font-bold uppercase tracking-wider mb-2 ${isDarkMode ? 'text-emerald-400' : 'text-emerald-600'}`}>Step {item.step}</div>
              <h3 className="text-sm sm:text-base font-bold mb-2">{item.title}</h3>
              <p className={`text-xs sm:text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{item.desc}</p>
              {i < 4 && (
                <div className="hidden md:block absolute top-1/2 -right-2 transform -translate-y-1/2">
                  <ChevronRight className={`w-4 h-4 ${isDarkMode ? 'text-slate-600' : 'text-slate-300'}`} />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <button 
            onClick={handleCTAClick} 
            data-testid="teacher-section-cta" 
            className="px-8 py-4 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white rounded-xl font-bold text-lg hover:-translate-y-1 transition-all shadow-xl shadow-emerald-500/30 inline-flex items-center gap-2"
          >
            Start Teaching Free <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksTeachers;
